import classNames from 'classnames';
import { ResortPhotosData } from 'components/widget/types';
import React, { useCallback, useRef } from 'react';
import { SwiperSlide, Swiper } from 'swiper/react';
import 'swiper/css';
import { ReactComponent as SvgArrowWhiteBg } from 'public/assets/icons/arrow-white-bg.svg';
import SwiperCore, { Navigation } from 'swiper';
import { ImageComponent } from 'components/common/ImageComponent';
import styles from './styles.module.scss';
import { SectionHeader } from '../SectionHeader';

SwiperCore.use([Navigation]);

interface Props {
  photos: ResortPhotosData;
  resortDescription?: { dangerouslySetInnerHTML: { __html: string; }; };
}

export const OverviewTopSlider = ({
  photos, resortDescription,
}:Props) => {
  const sliderRef = useRef<SwiperCore | null>(null);
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const shouldShowNavigation = photos.length > 1;

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.slideNext();
  }, []);

  return (
    <section id={styles.slider}>
      <div>
        {shouldShowNavigation && (
        <>
          <button
            type="button"
            ref={prevRef}
            className={classNames(styles.swiperNavButton, styles.swiperButtonPrev)}
            onClick={handlePrev}
          >
            <SvgArrowWhiteBg />
          </button>

          <button
            type="button"
            ref={nextRef}
            className={classNames(styles.swiperNavButton, styles.swiperButtonNext)}
            onClick={handleNext}
          >
            <SvgArrowWhiteBg />
          </button>
        </>
        )}
        <Swiper
          slidesPerView="auto"
          onSwiper={(swiperInstance) => {
            sliderRef.current = swiperInstance;
          }}
        >
          {photos.map((item) => (
            <SwiperSlide className={styles.height_auto}>
              <ImageComponent
                alt={item.name}
                src={item.cdnUrl}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <SectionHeader description={resortDescription} />
    </section>
  );
};
